<template>
  <v-container fluid>
    <div id="content">
      
      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
      </section>

      <v-card flat>

        <v-sheet class="d-flex justify-space-between">
          <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
            <v-icon>fas fa-chevron-left</v-icon>
          </v-btn>
          <v-menu
            v-model="viewDate"
            :close-on-content-click="false"
            :nudge-right="0"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-btn text class="ma-2" v-on="on">
                {{ calendarTitle }}
              </v-btn>
            </template>
            <v-date-picker 
              v-model="calendar" 
              type="month"
              @change="dateFormat"
              @input="viewDate = false">
            </v-date-picker>
          </v-menu>
          <v-btn icon class="ma-2" @click="$refs.calendar.next()">
            <v-icon>fas fa-chevron-right</v-icon>
          </v-btn>
        </v-sheet>

        <v-sheet :height="calendarHeight" v-if="!loading">
          <v-calendar
            ref="calendar"
            v-model="calendar"
            :show-month-on-first="false"
            :day-format="timestamp => new Date(timestamp.date).getDate()"
            :month-format="timestamp => (new Date(timestamp.date).getMonth() + 1) + ' /'"
            :events="desserts"
            @change="viewChange"
            @mousedown:event="clickEvent"
            @mousedown:day="mouseStart"
            @mousemove:day="mouseMove"
            @mouseup:day="mouseEnd"
            @mouseleave.native="mouseCancel"
            @touchstart:event="touchEvent"
            @touchmove:event="touchMove"
            @touchstart:day="mouseStart"
            @touchmove:day="mouseMove"
            @touchend:day="mouseEnd">
            <template v-slot:event="{ event }">
              <div :class="['label', event.disabled ? 'disabled' : '']">
                {{ event.name }}
                <template v-if="event.probate">
                  <span class="probate">承認済</span>
                </template>
              </div>
            </template>
          </v-calendar>
        </v-sheet>

      </v-card>

      <!-- 編集ダイアログ -->
      <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="600" id="dialog" class="edit-dialog">
        <v-card flat class="drawer-card">
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">{{ $route.name }}を{{ this.editedIndex === -1 ? '追加' : '編集' }}</span>
          </v-card-title>
          <v-card-text class="scroll-content">
            <v-form v-model="valid">
              <section class="accordion_inner">
                <v-row no-gutters>
                  <v-col cols="6" class="pa-2">
                    <v-text-field
                      ref="start"
                      label="日付"
                      v-model="editedItem.start"
                      :rules="[rules.required]"
                      class="required"
                      outlined hide-details="auto" disabled>
                    </v-text-field>
                  </v-col>
                  <v-col cols="6" class="pa-2">
                    <v-text-field
                      ref="user"
                      label="氏名"
                      v-model="editedItem.user"
                      :rules="[rules.required]"
                      class="required"
                      outlined hide-details="auto" disabled>
                    </v-text-field>
                  </v-col>
                </v-row>
                <div class="section-title">作業内容</div>
                <v-data-table
                  :headers="itemHeaders"
                  :items="editedItem.works"
                  :loading="loading"
                  hide-default-footer
                  disable-pagination>
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="(item, index) in items" :key="index" class="work-list">
                        <td>
                          <v-text-field
                            v-model="item.projectID"
                            :rules="[rules.required]"
                            class="required"
                            :readonly="editedItem.probate"
                            dense hide-details="auto">
                          </v-text-field>
                        </td>
                        <td>
                          <v-combobox
                            :ref="'workType_' + index"
                            v-model="item.worktypeID"
                            :items="worktypeItems"
                            append-icon=""
                            :rules="[rules.required]"
                            class="required"
                            :readonly="editedItem.probate"
                            @click.stop="editedItem.probate ? null : openSelected('workType_' + index)"
                            dense single-line hide-details="true">
                            <template v-slot:selection="{ item }">
                              <template v-if="maxLen < item.code.length">
                                {{ item.code.substr(0, 5) + '...' }}
                              </template>
                              <template v-else>
                                {{ item.code }}
                              </template>
                            </template>
                          </v-combobox>
                        </td>
                        <td>
                          <v-text-field 
                            v-model="item.start" 
                            type="time"
                            :rules="[rules.required, rules.step15]"
                            class="required"
                            :readonly="editedItem.probate"
                            dense hide-details="auto"></v-text-field>
                        </td>
                        <td>
                          <v-text-field 
                            v-model="item.end"
                            type="time"
                            :rules="[rules.required, rules.step15]"
                            class="required"
                            @change="endChange(item, index)"
                            :readonly="editedItem.probate"
                            dense hide-details="auto"></v-text-field>
                        </td>
                        <td>
                          <template v-if="item.start && item.end">
                            <v-text-field :value="diffTime(item.start, item.end, false, getWorkTimes(editedItem.start))" class="text-right"
                              disabled dense hide-details="auto"></v-text-field>
                          </template>
                        </td>
                        <td>
                          <span @click="trash(index)" v-if="!editedItem.probate">
                            <v-icon small>fas fa-times</v-icon>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr class="table-footer">
                        <td class="row-ctrl" colspan="2" rowspan="7">
                          <v-btn small text @click.stop="addRow" v-if="!editedItem.probate">
                            <v-icon left>far fa-plus-square</v-icon>
                            行の追加
                          </v-btn>
                          <div class="probate" v-if="editedItem.probate">
                            <span>承認</span>
                          </div>
                        </td>
                        <td colspan="2" class="text-center">通常</td>
                        <td class="text-right">
                          <v-text-field :value="totalTime" class="text-right"
                            disabled dense hide-details="auto"></v-text-field>
                        </td>
                        <td></td>
                      </tr>
                      <tr class="table-footer">
                        <td colspan="2" class="text-center">残業</td>
                        <td class="text-right">
                          <v-text-field :value="fixedTime('overTime')" class="text-right"
                            disabled dense hide-details="auto"></v-text-field>
                        </td>
                        <td></td>
                      </tr>
                      <tr class="table-footer">
                        <td colspan="2" class="text-center">深夜</td>
                        <td class="text-right">
                          <v-text-field :value="fixedTime('midnightTime')" class="text-right"
                            disabled dense hide-details="auto"></v-text-field>
                        </td>
                        <td></td>
                      </tr>
                      <tr class="table-footer">
                        <td colspan="2" class="text-center">休日</td>
                        <td class="text-right">
                          <v-text-field :value="fixedTime('holidayTime')" class="text-right"
                            disabled dense hide-details="auto"></v-text-field>
                        </td>
                        <td></td>
                      </tr>
                      <tr class="table-footer">
                        <td colspan="2" class="text-center">休日深夜</td>
                        <td class="text-right">
                          <v-text-field :value="fixedTime('holidayMignightTime')" class="text-right"
                            disabled dense hide-details="auto"></v-text-field>
                        </td>
                        <td></td>
                      </tr>
                      <tr class="table-footer">
                        <td colspan="2" class="text-center">法定休日</td>
                        <td class="text-right">
                          <v-text-field :value="fixedTime('legalHolidayTime')" class="text-right"
                            disabled dense hide-details="auto"></v-text-field>
                        </td>
                        <td></td>
                      </tr>
                      <tr class="table-footer">
                        <td colspan="2" class="text-center">法定休日深夜</td>
                        <td class="text-right">
                          <v-text-field :value="fixedTime('legalHolidayMignightTime')" class="text-right"
                            disabled dense hide-details="auto"></v-text-field>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </section>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid || isEdit" text x-large>
              <v-icon left>fas fa-save</v-icon>{{ this.editedIndex === -1 ? '登録' : '更新' }}
            </v-btn>
            <v-btn color="error" @click.stop="remove" :loading="saving" :disabled="editedItem.probate" v-if="editedIndex > -1" text x-large>
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="dialog = false" text x-large>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation, Storage } from 'aws-amplify'
import { 
  createDialy, updateDialy, deleteDialy,
  createWork, updateWork, deleteWork,
  createCustomer, createProject } from '../graphql/mutations'
import { 
  getDialy,
  listAppOptions, listEvents,
  listProjects, listCustomers, listWorkTypes, listWorkTimeGroups, getWorkTimeGroup,
  listUsers } from '../graphql/queries'
import { 
  onCreateEvent, onUpdateEvent, onDeleteEvent,
  onCreateDialy, onUpdateDialy, onDeleteDialy,
  onCreateProject, onUpdateProject, onDeleteProject,
  onCreateCustomer, onUpdateCustomer, onDeleteCustomer,
  onCreateWorkType, onUpdateWorkType, onDeleteWorkType } from '../graphql/subscriptions'
import moment from 'moment'

export default {
  data() {
    return {
      search: '',
      loading: true,
      dialog: false,
      valid: false,
      saving: false,
      appOptions: {},
      events: [],
      dialy: [],
      editedIndex: -1,
      editedItem: {},
      types: [
        { value: 1, text: '休日' },
        { value: 2, text: 'イベント' },
      ],
      calendar: moment().format('YYYY-MM-DD'),
      viewDate: false,
      editEvent: false,
      createEvent: null,
      createStart: null,
      hookFlg: false,
      itemHeaders: [
        { text: '注番', align: 'start', value: 'projectID', sortable: false, class: 'project-id' },
        { text: '種別', align: 'start', value: 'worktypeID', sortable: false, class: 'worktype-id' },
        { text: '開始', align: 'start', value: 'start', sortable: false, width: 80 },
        { text: '終了', align: 'start', value: 'end', sortable: false, width: 80 },
        { text: '小計', align: 'end', value: 'total', sortable: false, width: 100 },
        { text: '', align: 'center', value: 'ctrl', sortable: false, width: 30 },
      ],
      projects: [],
      customers: [],
      worktypes: [],
      worktimes: [],
      users: [],
      origin: [],
      maxLen: 4,
      start: null,
      end: null,
    }
  },
  prop: {},
  mounted: async function() {
    //設定 query
    const appOptionQuery = await API.graphql(graphqlOperation(listAppOptions, { limit: 100 }))
    for (const row of appOptionQuery.data.listAppOptions.items) {
      this.appOptions[row.name] = row.value
    }
    //プロジェクト query
    await this.getProjects()
    //ユーザー query
    await this.getUsers()
    //客先 query
    await this.getCustomers()
    //作業種別 query
    await this.getWorkTypes()
    //労務・休憩時間 query
    await this.getWorkTimeGroups()
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateEvent)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateEvent
        this.events.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateEvent)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateEvent
        this.events.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteEvent)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteEvent
        this.events = this.events.filter(origin => origin.id !== row.id)
      }
    })
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateDialy)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateDialy
        // console.log(row, this.getMyself().id)

        if (row.userID != this.getMyself().id) return

        const date = moment(row.start)
        const start = moment(this.start).subtract(1, 'day')
        const end = moment(this.end)
        if (start <= date && end >= date) {
          this.dialy.push(Object.assign({
            name: row.start + ' 日報'
          }, row))
        }
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateDialy)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateDialy
        this.dialy.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteDialy)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteDialy
        this.dialy = this.dialy.filter(origin => origin.id !== row.id)
      }
    })
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateProject)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateProject
        this.projects.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateProject)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateProject
        this.projects.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteProject)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteProject
        this.projects = this.projects.filter(origin => origin.id !== row.id)
      }
    })
    //customer作成時 subscription
    await API.graphql(graphqlOperation(onCreateCustomer)).subscribe({
      next: (e) => {
        const data = e.value.data.onCreateCustomer
        this.customers.push(data)
      }
    })
    //customer更新時 subscription
    await API.graphql(graphqlOperation(onUpdateCustomer)).subscribe({
      next: (e) => {
        const data = e.value.data.onUpdateCustomer
        this.customers.find(origin => {
          if (origin.value === data.id) {
            origin = Object.assign(origin, data)
          }
        })
      }
    })
    //customer削除時 subscription
    await API.graphql(graphqlOperation(onDeleteCustomer)).subscribe({
      next: (e) => {
        const data = e.value.data.onDeleteCustomer
        this.customers = this.customers.filter(origin => origin.value !== data.id)
      }
    })
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateWorkType)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateWorkType
        this.worktypes.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateWorkType)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateWorkType
        this.worktypes.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteWorkType)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteWorkType
        this.worktypes = this.worktypes.filter(origin => origin.id !== row.id)
      }
    })
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
    let timer = setInterval(() => {
      if (this.getMyself()) {
        clearInterval(timer)
        this.init()
      }
    }, 100)
  },
  computed: {
    form() {
      return {
        id: this.editedItem.id || null,
        userID: this.editedItem.userID,
        start: this.editedItem.start || null,
        //probate: this.editedItem.probate || false,
        unlock: this.editedItem.unlock || false,
        //totalTime: this.editedItem.totalTime ? this.editedItem.totalTime * 60 : 0,
        //overTime: this.editedItem.overTime ? this.editedItem.overTime * 60 : 0,
        //midnightTime: this.editedItem.midnightTime ? this.editedItem.midnightTime * 60 : 0,
        //holidayTime: this.editedItem.holidayTime ? this.editedItem.holidayTime * 60 : 0,
        //holidayMignightTime: this.editedItem.holidayMignightTime ? this.editedItem.holidayMignightTime * 60 : 0,
        //legalHolidayTime: this.editedItem.legalHolidayTime ? this.editedItem.legalHolidayTime * 60 : 0,
        //legalHolidayMignightTime: this.editedItem.legalHolidayMignightTime ? this.editedItem.legalHolidayMignightTime * 60 : 0,
      }
    },
    //カレンダーのタイトル
    calendarTitle() {
      return moment(this.calendar).format('YYYY年 M月')
    },
    //カレンダーの高さ
    calendarHeight() {
      const min = 600
      const height = window.innerHeight - 250
      return height < min ? min : height
    },
    //イベント+日報データ
    desserts() {
      return this.events.concat(this.dialy)
    },
    //集計
    totalTime() {
      //項目ごとの集計
      this.calc()

      return this.fixedTime('totalTime')
    },
    projectItems() {
      const map = []
      for (const item of this.projects) {
        let text = ''
        if (item.code) text += '[ ' + item.code + ' ] '
        if (item.name) text += item.name
        map.push({
          value: item.id,
          text: text,
          code: item.code ? item.code : item.name,
        })
      }
      //コード順でソート
      map.sort(function(a,b) {
        if (a.code < b.code) return -1
        if (a.code > b.code) return 1
        return 0
      })
      return map
    },
    worktypeItems() {
      const map = []
      for (const item of this.worktypes) {
        let text = ''
        if (item.code) text += '[ ' + item.code + ' ] '
        if (item.name) text += item.name
        map.push({
          value: item.id,
          text: text,
          code: item.code ? item.code : item.name,
          name: item.name,
        })
      }
      //コード順でソート
      map.sort(function(a,b) {
        if (a.code < b.code) return -1
        if (a.code > b.code) return 1
        return 0
      })
      return map
    },
    isEdit() {
      const bool = (!this.editedItem.probate || this.editedItem.unlock) || false

      return !bool
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    async editedItem(val) {
      if (val.id) {
        this.saving = true
        //console.log(this.editedItem)
        await this.getWorks(this.editedItem.works, val.id)

      } else {
        //オリジナルはなし
        this.origin = []
      }
    },
  },
  methods: {
    //初期化
    async init() {
      this.loading = false
      //this.load(true)
    },
    //保存
    async save() {
      try {
        this.saving = true
        const data = Object.assign({}, this.form)

        // 有給残日数のチェック
        const user = this.users.find(u => u.value == this.editedItem.userID)
        // 労務・休憩時間
        const workTimes = this.getWorkTimes(this.editedItem.start)
        // 15:00-15:15の休憩時間を除外
        const restTimes = workTimes.filter(e => e.start !== '15:00')

        var maxDaysOfPaidTime = 0
        var dailyWorktime = 0
        if (user) {
          dailyWorktime = user.dailyWorktime || 0
          maxDaysOfPaidTime = parseInt(this.appOptions.maxDaysOfPaidTime) * dailyWorktime
        }

        if (user) {
          for (const item of this.editedItem.works) {
            if (item.worktypeID && item.worktypeID.name == '有給') {
              const time = this.diffTime(
                item.start,
                item.end,
                true,
                restTimes,
              )
              
              if (time >= dailyWorktime && user.paidRemain < 1) {
                throw new Error('有給残日数が不足しているため、保存できません')
              } else if (time < dailyWorktime) {
                if (user.paidHoursUsed + Math.ceil(time) > maxDaysOfPaidTime) {
                  throw new Error('時間有給取得可能時間を超えているため、保存できません')
                } else if (user.paidRemain * dailyWorktime < Math.ceil(time)) {
                  throw new Error('有給残日数が不足しているため、保存できません')
                }
              }
            }
          }
        }
        
        //編集
        if (data.id) {
          await API.graphql(graphqlOperation(updateDialy, {input: data}))
          this.log({ type: this.$route.name, text: '[日報:' + data.start + '] を更新しました' })
          this.myAlert(data.start + 'の日報を更新しました', 'success')

        //新規
        } else {
          delete data.id
          const ret = await API.graphql(graphqlOperation(createDialy, {input: data}))
          this.editedItem.id = ret.data.createDialy.id
          this.log({ type: this.$route.name, text: '[日報:' + data.start + '] を追加しました' })
          this.myAlert(data.start + 'の日報を追加しました', 'success')
        }

        //作業内容の保存
        for (const item of this.editedItem.works) {
          const work = await this.getWork(item)
          if (item.id) {
            await API.graphql(graphqlOperation(updateWork, {input: work}))
          } else {
            delete work.id
            await API.graphql(graphqlOperation(createWork, {input: work}))
          }
        }
        //オリジナルにのみ存在するものは削除
        for (const work of this.origin) {
          if (!this.editedItem.works.find(e => e.id === work.id)) {
            await API.graphql(graphqlOperation(deleteWork, {
              input: { id: work.id }
            }))
          }
        }

        this.dialog = false

      } catch (e) {
        //console.log(e)
        this.myAlert(e)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        if (confirm(this.editedItem.start + 'を削除しますか？')) {
          //削除
          await API.graphql(graphqlOperation(deleteDialy, {
            input: { id: this.editedItem.id }
          }))
          this.log({ type: this.$route.name, text: '[[日報:' + this.editedItem.start + '] を削除しました' })
          this.myAlert('日報:' + this.editedItem.start + 'を削除しました', 'success')
          this.dialog = false
        }

      } catch (error) {
        this.myAlert(error)
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      this.editEvent = false
      this.mouseCancel()
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f] && !!this.$refs[f].reset) this.$refs[f].reset()
      })
      this.editedItem.id = null
    },
    //イベントクリック
    clickEvent({ event }) {
      //編集不可イベントの場合は抜ける
      if (event.disabled) return

      this.editEvent = true
      //イベントの編集ダイアログを表示
      const target = this.dialy.find(e => e.id === event.id)
      const user = this.users.find(e => e.value == target.userID)
      
      this.editedIndex = this.dialy.findIndex(e => e.id === event.id)
      this.editedItem = {
        id: target.id,
        start: target.start,
        user: user.text,
        probate: target.probate,
        unlock: target.unlock,
        works: [],
        //totalTime: target.totalTime ? target.totalTime / 60 : 0,
        //overTime: target.overTime ? target.overTime / 60 : 0,
        //midnightTime: target.midnightTime ? target.midnightTime / 60 : 0,
        //holidayTime: target.holidayTime ? target.holidayTime / 60 : 0,
        //holidayMignightTime: target.holidayMignightTime ? target.holidayMignightTime / 60 : 0,
        //legalHolidayTime: target.legalHolidayTime ? target.legalHolidayTime / 60 : 0,
        //legalHolidayMignightTime: target.legalHolidayMignightTime ? target.legalHolidayMignightTime / 60 : 0,
      }
      this.dialog = true
    },
    //イベントタッチ
    touchEvent(info) {
      this.editEvent = true
      setTimeout(function(path) {
        if (path.editEvent) path.clickEvent(info)
      }, 500, this)
    },
    //イベントタッチして移動
    touchMove() {
      this.editEvent = false
    },
    //日付タップ
    mouseStart(view) {
      if (!this.editEvent) {
        this.hookFlg = true
        setTimeout(function(path) {
          if (path.hookFlg) path.hookEvent(view)
        }, 500, this)
      }
    },
    //新しいイベント生成
    hookEvent(view) {
      //日報ロック日数以前の日報は作成不可
      if (moment(view.date) < moment().subtract(this.appOptions.dialyLockDays, 'days')) {
        this.myAlert('選択された日付の日報は作成できません', 'error')
        this.mouseCancel()
        return

      //同日に日報作成済みであればダイアログ表示
      } else if (this.dialy.find(e => e.start == view.date)) {
        this.myAlert('選択された日付は日報を作成済みです', 'error')
        this.mouseCancel()
        return
      }

      this.createStart = view.date
      this.createEvent = {
        name: '選択中',
        start: this.createStart,
        userID: this.getMyself().id,
        user: this.getMyself().last + ' ' + this.getMyself().first,
      }
      this.dialy.push(this.createEvent)
    },
    //日付ドラッグ中
    mouseMove(view) {
      this.hookFlg = false
      //休日または日を跨ぐ場合は作成不可
      if (moment(this.createStart).format('YYYY-MM-DD') != moment(view.date).format('YYYY-MM-DD'))  return
    },
    //タイムテーブル ドラッグ終了
    mouseEnd() {
      this.hookFlg = false
      if (this.createEvent && this.createStart) {
        //新しいイベントの登録ダイアログを表示
        this.editedItem = {
          start: moment(this.createEvent.start).format('YYYY-MM-DD'),
          user: this.createEvent.user,
          userID: this.createEvent.userID,
          works: [],
          probate: false,
          unlock: false,
          totalTime: 0,
          overTime: 0,
          midnightTime: 0,
          holidayTime: 0,
          holidayMignightTime: 0,
          legalHolidayTime: 0,
          legalHolidayMignightTime: 0,
        }
        this.dialog = true
      }
    },
    //タイムテーブル ドラッグ範囲外
    mouseCancel() {
      if (this.dialog) return

      this.dialy = this.dialy.filter(e => e !== this.createEvent)

      this.createEvent = null
      this.createStart = null
    },
    //作業内容の追加
    addRow() {
      let start = null
      if (this.editedItem.works.length > 0) {
        const last = this.editedItem.works.slice(-1)[0]
        if (last.end) start = last.end
      }
      this.editedItem.works.push({
        projectID: null,
        worktypeID: null,
        start: start,
        end: null,
      })
    },
    //品目の削除
    trash(index) {
      this.editedItem.works.splice(index, 1)
    },
    //カレンダー表示日
    dateFormat() {
      this.calendar = moment(this.calendar).format('YYYY-MM-DD')
    },
    //項目集計
    calc() {
      let sum = 0
      let overTime = 0, midnightTime = 0
      let start = null, end = null
      let holiday = false
      let legalHoliday = false

      if (this.editedItem.works) {
        //総時間
        for (const item of this.editedItem.works) {
          if (!start) start = moment(item.start, 'HH:mm')
          end = moment(item.end, 'HH:mm')
          //if (item.start && item.end) sum += this.diffTime(item.start, item.end, true)
        }
        //終業時刻が日を跨ぐか
        if (end && end.hour() == 0) end.add(1, 'days')

        if (start && end) {
          
          //休日かどうか
          for (const item of this.events) {
            if (moment(item.start) <= moment(this.editedItem.start) && 
                moment(item.end) >= moment(this.editedItem.start)) {
              holiday = true
              break
            }
          }
          //法定休日かどうか
          if (moment(this.editedItem.start).day() == 0) {
            legalHoliday = true
          }
          
          //残業・深夜計算
          for (const item of this.editedItem.works) {
            var time = this.diffSectionTime(
              item.start,
              item.end,
              this.getWorkTimes(this.editedItem.start),
            )

            // 欠勤は計算しない 2025.12.08
            if (item.worktypeID && item.worktypeID.name == '欠勤') {
              time = { sum: 0, over: 0, midnight: 0 }
            }

            //通常
            sum += time.sum
            //残業
            overTime += time.over
            //深夜
            midnightTime += time.midnight
          }
          
          //通常
          if (!holiday) this.editedItem.totalTime = sum
          //通常残業
          if (!holiday) this.editedItem.overTime = overTime
          //通常深夜
          if (!holiday) this.editedItem.midnightTime = midnightTime
          //休日
          if (holiday && !legalHoliday) this.editedItem.holidayTime = sum + overTime
          //休日深夜
          if (holiday && !legalHoliday) this.editedItem.holidayMignightTime = midnightTime
          //法定休日
          if (holiday && legalHoliday) this.editedItem.legalHolidayTime = sum + overTime
          //法定休日深夜
          if (holiday && legalHoliday) this.editedItem.legalHolidayMignightTime = midnightTime
        }
      }
    },
    //時間の小数点以下桁揃え
    fixedTime(name, keta = 2) {
      return this.editedItem[name] ? this.editedItem[name].toFixed(keta) : Number(0).toFixed(keta)
    },
    //ビュー変更
    async viewChange({start, end}) {
      //this.load(true)

      this.events = []
      this.dialy = []

      this.start = moment(start.date).subtract(7, 'days').format('YYYY-MM-DD')
      this.end = moment(end.date).add(7, 'days').format('YYYY-MM-DD')

      await this.getEvents(this.start, this.end)
      await this.getDialys(this.start, this.end)
    },
    //終了時間の変更
    endChange(item, index) {
      const start = moment(item.start, 'HH:mm')
      const end = moment(item.end, 'HH:mm')

      if (start > end && end.format('HH:mm') != '00:00') {
        this.myAlert('終了時刻は開始時刻より早い時刻を設定して下さい', 'error')
        this.editedItem.works[index].end = start.format('HH:mm')
      }

      if (this.editedItem.works[index + 1] && !this.editedItem.works[index + 1].start) {
        this.editedItem.works[index + 1].start = end.format('HH:mm')
      }
      
    },
    //イベントの取得
    async getEvents(start, end, nextToken = null) {
      const query = await API.graphql(graphqlOperation(listEvents, {
        filter: {
          and: [
            { start: { ge: moment(start).subtract(1, 'day').format('YYYY-MM-DDTHH:mm:ss') } },
            { end: { le: moment(end).format('YYYY-MM-DDTHH:mm:ss') } },
          ],
        },
        limit: 100,
        nextToken: nextToken
      }))
      for (const data of query.data.listEvents.items) {
        this.events.push(Object.assign(data, {
          disabled: true,
        }))
      }
      if (query.data.listEvents.nextToken) this.getEvents(start, end, query.data.listEvents.nextToken)
    },
    //日報の取得
    async getDialys(start, end) {
      const values = await API.post(
        'restapi', 
        '/queryDialys', 
        {
          body: {
            start: moment(start).subtract(1, 'day').format('YYYY-MM-DDTHH:mm:ss'),
            end: moment(end).format('YYYY-MM-DDTHH:mm:ss'),
            userID: this.getMyself().id,
          },
          headers: {
            'Content-Type' : 'application/json',
          }
        }
      )
      for (const item of values.data.items) {
        this.dialy.push(Object.assign({
          name: item.start + ' 日報'
        }, item))
      }
      //this.load(false)
    },
    //作業内容の取得
    async getWorks(target, dialyID) {
      const ret = await API.graphql(graphqlOperation(getDialy, { id: dialyID }))
      const items = ret.data.getDialy.works.items

      for (const item of items) {
        const project = this.projectItems.find(e => e.value == item.projectID)
        target.push({
          id: item.id,
          dialyID: item.dialyID,
          projectID: project ? project.code : null,
          worktypeID: this.worktypeItems.find(e => e.value == item.worktypeID),
          start: this.unixToTime(item.start),
          end: this.unixToTime(item.end),
        })
      }

      //オリジナルをコピーしておく
      this.origin = [...target]
      //作成日付降順でソート
      target.sort(function(a,b) {
        if (a.start < b.start) return -1
        if (a.start > b.start) return 1
        return 0
      })

      this.saving = false
    },
    //作業内容
    async getWork(item) {
      let project = this.projectItems.find(e => e.code === item.projectID)
      //プロジェクトが未登録
      if (!project) {
        let customer = this.customers.find(e => e.name === '未設定')
        //客先が未登録
        if (!customer) {
          //客先を「未設定」で登録
          const customer_ret = await API.graphql(graphqlOperation(createCustomer, {input: {
            name: '未設定',
            payment: ['銀行振込'],
          }}))
          this.log({ type: this.$route.name, text: '客先 [' + customer_ret.data.createCustomer.name + '] を追加しました' })
          customer = { id: customer_ret.data.createCustomer.id }
        }
        //プロジェクトを「未設定」で登録
        const project_ret = await API.graphql(graphqlOperation(createProject, {input: {
          code: item.projectID,
          name: '未設定',
          customerID: customer.id,
        }}))
        await Storage.put('project/description/' + project_ret.data.createProject.id + '.html', '')
        this.log({ type: this.$route.name, text: 'プロジェクト [' + project_ret.data.createProject.name + '] を追加しました' })
        project = { value: project_ret.data.createProject.id }
      }

      return {
        id: item.id || null,
        dialyID: this.editedItem.id || null,
        projectID: project.value,
        worktypeID: item.worktypeID.value,
        start: moment(item.start, 'HH:mm').unix(),
        end: moment(item.end, 'HH:mm').unix(),
      }
    },
    //労務時間の取得
    getWorkTimes(date) {
      const map = []

      if (date) {
        for (const item of this.worktimes) {
          if (item.start <= date && item.end >= date) {
            return item.workTimes

          } else if (!item.start && item.end >= date) {
            return item.workTimes

          } else if (!item.end && item.start <= date) {
            return item.workTimes
          }
        }
      }

      return map
    },
    //プロジェクトの取得
    async getProjects(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listProjects, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listProjects.items) {
        this.projects.push(data)
      }
      if (query.data.listProjects.nextToken) this.getProjects(query.data.listProjects.nextToken)
    },
    //客先の取得
    async getCustomers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listCustomers, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listCustomers.items) {
        this.customers.push(data)
      }
      if (query.data.listCustomers.nextToken) this.getCustomers(query.data.listCustomers.nextToken)
    },
    //作業種別の取得
    async getWorkTypes(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTypes, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listWorkTypes.items) {
        this.worktypes.push(data)
      }
      if (query.data.listWorkTypes.nextToken) this.getWorkTypes(query.data.listWorkTypes.nextToken)
    },
    //労務・休憩時間の取得
    async getWorkTimeGroups(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTimeGroups, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listWorkTimeGroups.items) {
        const ret = await API.graphql(graphqlOperation(getWorkTimeGroup, { id: data.id }))
        const items = ret.data.getWorkTimeGroup.workTimes.items

        items.sort(function(a, b) {
          if (a.start < b.start) return -1
          if (a.start > b.start) return 1
        })
        data.workTimes = items

        this.worktimes.push(data)
      }
      if (query.data.listWorkTimeGroups.nextToken) {
        this.getWorkTimeGroups(query.data.listWorkTimeGroups.nextToken)
      }
    },
    //ユーザーの取得
    async getUsers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listUsers, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listUsers.items) {
        this.users.push({
          value: data.id,
          text: data.last + ' ' + data.first,
          paidRemain: data.paidRemain,
          paidHoursUsed: data.paidHoursUsed,
          dailyWorktime: parseInt(data.dailyWorktime) || 0,
        })
      }
      if (query.data.listUsers.nextToken) this.getUsers(query.data.listUsers.nextToken)
    },
  },
}
</script>

<style lang='scss' scoped>
.v-event {
  .label {
    position: relative;
    &.disabled {
      background: rgba(255, 255, 255, .5);
      cursor: not-allowed;
    }
    .probate {
      font-size: 10px;
      background: #e84b3c;
      margin-left: 5px;
      padding: 0 5px;
      border-radius: 2px;
      color: #FFF;
    }
  }
}
.section-title {
  margin: 10px 0;
  padding: 5px 10px;
  font-weight: bold;
  background: #e1ecf3;
}
tbody {
  tr {
    &:hover {
      background: transparent !important;
    }
    &.ghost {
      opacity: 0.5 !important;
      background: #c8ebfb !important;
    }
    td {
      .handle {
        &:hover {
          cursor: move;
        }
      }
      .probate {
        position: relative;
        span {
          color: #E00;
          border: 3px solid #E00;
          border-radius: 10px;
          font-size: 18px;
          padding: 3px 20px;
          position: absolute;
          top: 50px;
          left: 20px;
          transform: rotate(355deg);
        }
      }
    }
  }
}
.table-footer {
  &:first-of-type td {
    border-top: thin solid rgba(0, 0, 0, 0.12);
  }
  &:hover {
    background: #FFF !important;
  }
  td {
    cursor: default !important;
    &.row-ctrl {
      vertical-align: top;
      padding-top: 10px;
      border-bottom: none !important;
    }
  }
}
.item-ctrl {
  text-align: right;
}
.work-list {
  .v-select {
    white-space: nowrap;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid #999;
  }
}

</style>
